import AlertCell from "../AlertCell"
import { AlertResponse } from "@/api/AlertsService"

export interface AlertCellRendererProps {
   alarm: AlertResponse | null
}

export function AlertCellRenderer(props: AlertCellRendererProps) {
   return <AlertCell {...props} />
}
